export const AWS_CONTACT_US_LINK = "https://aws.amazon.com/contact-us";

export enum MIME_TYPE {
    OCTET_STREAM = "application/octet-stream",
}

export const UNKNOWN_STATUS_CODE = 0;
